type ZonePathInfo = {
  grandGrandParentName?: string;
  grandParentName?: string;
  parentName?: string;
  name?: string;
};

type ZonePathExtended<T> = T & {
  zonePath?: string;
};

export class ZonePathUtil {
  public static readonly extendedZonePathFieldName = 'zonePath';

  public static extendByZonePath<T extends ZonePathInfo>(zoneInfo: T): T {
    if (!zoneInfo) {
      return null;
    }
    const extendedZoneInfo = zoneInfo as ZonePathExtended<T>;
    extendedZoneInfo[ZonePathUtil.extendedZonePathFieldName] = ZonePathUtil.getZonePath(zoneInfo);
    return extendedZoneInfo;
  }

  public static getZonePath<T extends ZonePathInfo>(zone: T): string {
    if (!zone) {
      return null;
    }
    return [zone.grandGrandParentName, zone.grandParentName, zone.parentName, zone.name].filter(Boolean).join(' / ');
  }
}